/* eslint-disable camelcase */
import qs from 'qs'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Button from '../../components/buttons/Button'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import { loginUser, setAuthForm } from '../../store/features/auth/authSlice'
import Logo from '../../components/logo/Logo'
import { AuthForm, ForgetPasswordForm } from '../../store/features/auth/type'
import { useState } from 'react'
import Login from './components/Login'
import ForgetPassword from './components/ForgetPassword'

interface IForms {
  username: string
  password: string
}

const LoginForm = () => {
  const { t } = useTranslation()
  const { forgetPasswordForm } = useAppSelector((state) => state.auth)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { setUser, setUserinfomation } = useAuth()

  const schema: yup.SchemaOf<IForms> = yup.object({
    username: yup.string().required('requiedUerNameFeild'),
    password: yup.string().required('requiedPasswordFeild'),
  })

  const {
    formState: { errors },
  } = useForm<IForms>({
    resolver: yupResolver(schema),
  })

  const onSubmit: SubmitHandler<IForms> = (data) => {
    const { username, password } = data
    const loginData = qs.stringify({
      username,
      password,
      grant_type: process.env.REACT_APP_GRAND_TYPE,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
    })
    const commands = {
      loginData,
      navigate,
      setUser,
      setUserinfomation,
    }
    dispatch(loginUser(commands))
  }

  const handleSetAuthFormRegisterClick = () => {
    dispatch(setAuthForm(AuthForm.Register))
  }
  const handleSetAuthFormPublicPreReserveClick = () => {
    dispatch(setAuthForm(AuthForm.PublicPreReserve))
  }

  return (
    <div className='flex items-center justify-center w-screen h-screen bg-neutral-50'>
      <div className='flex bg-white lg:w-1/2 md:w-3/4 w-4/5 shadow-lg rounded-xl'>
        {/* Login form section */}
        <div className='h-full w-full md:w-2/3 flex flex-col items-center justify-center p-8 lg:py-8 lg:px-4 '>
          <div className='flex lg:flex-row flex-col  items-center justify-center lg:justify-between md:-mr-3'>
            <div className='w-full lg:w-14 flex items-center justify-center mb-2'>
              <Logo classes='w-14 h-14 md:w-10 md:h-10' />
            </div>
            <p className='text-sm text-gray-500 text-center leading-7'>{t('loginWelcome')}</p>
          </div>
          {forgetPasswordForm === ForgetPasswordForm.LOGIN ? <Login /> : <ForgetPassword />}
        </div>

        {/* Logo section */}
        <div className=' bg-teal-300 hidden md:flex pt-8 w-1/2  rounded-tl-xl rounded-bl-xl'>
          <div className=' w-full flex flex-col items-center '>
            <a href='https://shahedankosar.com'>
              <div className='-mr-4 cursor-pointer'>
                <Logo classes='lg:w-36 lg:h-36 md:w-28 md:h-28' />
              </div>
              <p className='mt-3 lg:text-2xl md:text-xl font-bold text-white'>{t('companyName')}</p>
            </a>
            <p className='mt-9 text-sm text-white'>{t('dontHaveAccount')}</p>
            <div className='w-full px-8 mt-2'>
              <Button
                classes='w-full bg-white text-teal-400 hover:bg-white hover:text-teal-300'
                onClick={handleSetAuthFormRegisterClick}
              >
                {t('register')}
              </Button>
              <div
                className='px-8 w-full text-white hover:text-gray-600 cursor-pointer text-center mt-5 text-sm ease-in-out duration-200'
                onClick={handleSetAuthFormPublicPreReserveClick}
              >
                {t('tripPreReserve')}
              </div>{' '}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginForm
